import { Account } from 'src/api/@generated/backend-api';

import { setAccount } from 'src/state/account/account-slice';
import { resetStateForNewAccountActionCreator } from 'src/state/account/action-creators/reset-state-for-new-account-action-creator';
import { AppDispatch, RootState } from 'src/state/types';

export const selectAccountActionCreator = (account: Account) => (dispatch: AppDispatch, getState: () => RootState) => {
  const {
    account: { selectedAccount },
  } = getState();

  if (
    selectedAccount &&
    !(selectedAccount.partnerId === account.partnerId && selectedAccount.customerId === account.customerId)
  ) {
    dispatch(resetStateForNewAccountActionCreator());
  }
  dispatch(setAccount(account));
};
